import gsap from "gsap"; // Assuming you have GSAP in your build step

document.addEventListener('DOMContentLoaded', () => {
  const waitlistForm = document.querySelector('.waitlist-form form') || document.querySelector('.waitlist-form');
  const formWrapper = document.querySelector('.waitlist-form-wrapper');
  const successWrapper = document.querySelector('.waitlist-success-wrapper');

  // We check waitlistForm or fallback to '.waitlist-form' directly as shopify form helper adds class to form element itself.
  if (waitlistForm && formWrapper && successWrapper) {
    waitlistForm.addEventListener('submit', async (e) => {
      e.preventDefault(); // Stop the clunky page reload

      const formData = new FormData(waitlistForm);

      try {
        // Submit the data silently to Shopify's contact endpoint
        await fetch(window.location.pathname, {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        // The GSAP "Antigravity" Transition Timeline
        const tl = gsap.timeline();

        // 1. Float the form up and fade it out
        tl.to(formWrapper, {
          y: -20,
          opacity: 0,
          duration: 0.6,
          ease: "power3.inOut",
          onComplete: () => {
            formWrapper.style.display = 'none';
            successWrapper.style.display = 'block'; // Reveal the success DOM
          }
        })
        // 2. Float the success message in from below
        .fromTo(successWrapper, 
          { y: 20, opacity: 0 }, 
          { y: 0, opacity: 1, duration: 0.8, ease: "power4.out" }
        );

      } catch (error) {
        console.error('Waitlist submission failed:', error);
        // Handle error state animation here if needed
      }
    });
  }
});
